import Splide from '@splidejs/splide';
export const init = () => {
    if (document.querySelector('.carousel_type-1')) {
        const carousel1 = document.querySelectorAll('.carousel_type-1');
        carousel1.forEach((item) => {
            const splideCarousel1 = new Splide(item, {
                arrows: false,
                pagination: true,
                autoplay: false,
                interval: 2000,
                gap: 32,
                padding: 24,
                perPage: 3,
                perMove: 3,
                classes: {
                    pagination: 'splide__pagination g-pagination__type-1',
                },
                drag: false,
                breakpoints: {
                    1055: {
                        perPage: 2,
                    },
                    671: {
                        perPage: 1,
                        padding: 0,
                    },
                },
            },);
            splideCarousel1.mount();

            const arrowLeft = item.querySelector('.btn--prev');
            const arrowRight = item.querySelector('.btn--next');
            const { Controller } = splideCarousel1.Components;
            if (Controller.getPrev() === Controller.getNext()) {
                arrowLeft.parentElement.classList.add('hidden');
            }
            splideCarousel1.on('move', (newIndex) => {
                switch (newIndex) {
                    case 0:
                        arrowLeft.classList.add('disabled');
                        arrowRight.classList.remove('disabled');
                        break;
                    case Controller.getEnd():
                        arrowRight.classList.add('disabled');
                        arrowLeft.classList.remove('disabled');
                        break;
                    default:
                        arrowLeft.classList.remove('disabled');
                        arrowRight.classList.remove('disabled');
                }
            });

            arrowLeft.addEventListener('click', () => splideCarousel1.go('<'));
            arrowRight.addEventListener('click', () => splideCarousel1.go('>'));
        })
    }
}